<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="couponId" >
        <span slot="label" >
          <a-tooltip>
            优惠券ID，外键{coupon.id}<template slot="title">优惠券ID，外键{coupon.id}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.couponId"  :placeholder="$t('请输入')+'优惠券ID，外键{coupon.id}'" />
      </a-form-model-item>
      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            用户ID<template slot="title">用户ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId"  :placeholder="$t('请输入')+'用户ID'" />
      </a-form-model-item>
      <a-form-model-item prop="grantType" >
        <span slot="label" >
          <a-tooltip>
            发放来源：1-用户领取 2-后台手动 3-系统发放 4-积分兑换<template slot="title">发放来源：1-用户领取 2-后台手动 3-系统发放 4-积分兑换</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="operatorId" >
        <span slot="label" >
          <a-tooltip>
            操作人ID<template slot="title">操作人ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.operatorId"  :placeholder="$t('请输入')+'操作人ID'" />
      </a-form-model-item>
      <a-form-model-item prop="receiveTime" >
        <span slot="label" >
          <a-tooltip>
            领取/发放时间<template slot="title">领取/发放时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.receiveTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" >
          <a-tooltip>
            状态：1未使用 2已使用 3已过期 4已作废<template slot="title">状态：1未使用 2已使用 3已过期 4已作废</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="useTime" >
        <span slot="label" >
          <a-tooltip>
            使用时间<template slot="title">使用时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.useTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="orderId" >
        <span slot="label" >
          <a-tooltip>
            使用订单ID<template slot="title">使用订单ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderId"  :placeholder="$t('请输入')+'使用订单ID'" />
      </a-form-model-item>
      <a-form-model-item prop="expireTime" >
        <span slot="label" >
          <a-tooltip>
            到期时间<template slot="title">到期时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.expireTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="isLocked" >
        <span slot="label" >
          <a-tooltip>
            是否锁定<template slot="title">是否锁定</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.isLocked"  :placeholder="$t('请输入')+'是否锁定'" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCouponUser, addCouponUser, updateCouponUser } from '@/api/coupon/couponUser'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        couponId: null,

        userId: null,

        grantType: null,

        operatorId: null,

        receiveTime: null,

        status: 0,

        useTime: null,

        orderId: null,

        expireTime: null,

        isLocked: null,

        createTime: null,
        localeFieldMap:{},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        couponId: [
          { required: true, message: '优惠券ID，外键{coupon.id}'+this.$t('不能为空'), trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        grantType: [
          { required: true, message: '发放来源：1-用户领取 2-后台手动 3-系统发放 4-积分兑换'+this.$t('不能为空'), trigger: 'change' }
        ],
        operatorId: [
          { required: true, message: '操作人ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态：1未使用 2已使用 3已过期 4已作废'+this.$t('不能为空'), trigger: 'blur' }
        ],
        isLocked: [
          { required: true, message: '是否锁定'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        couponId: null,
        userId: null,
        grantType: null,
        operatorId: null,
        receiveTime: null,
        status: 0,
        useTime: null,
        orderId: null,
        expireTime: null,
        isLocked: null,
        createTime: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCouponUser({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCouponUser(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCouponUser(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
